import React, { useState } from "react";
import "../../../styles/calendare.css";
import { CaptionProps, DayPicker, SelectSingleEventHandler, useNavigation } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";

function CustomCaptionComponent(props: CaptionProps) {
  const { goToMonth, nextMonth, previousMonth } = useNavigation();

  return (
    <div>
      <button disabled={!previousMonth} onClick={() => previousMonth && goToMonth(previousMonth)} className="calendar-space img-calendar"><IoIosArrowBack /></button>
      <span className="rdp-caption_label">{format(props.displayMonth, "MMM yyy")}</span>
      <button disabled={!nextMonth} onClick={() => nextMonth && goToMonth(nextMonth)} className="img-calendar2"><IoIosArrowForward /></button>
      <span className="line-calendar"></span>
    </div>
  );
}

function MonthComponent() {

  const [selected, setSelected] = useState<Date | undefined>(undefined);

  const navigate = useNavigate();
  const handleDaySelect: SelectSingleEventHandler = (day) => {
    setSelected(day || undefined);
    if (day) {
      navigate(`/bets/calendar/day/${day.toISOString()}`);
    }
  };

  return (
      <div className="calendar-container">
        <DayPicker mode="single" selected={selected} onSelect={handleDaySelect} components={{
          Caption: CustomCaptionComponent
        }} />
      </div>
  );
}

export default MonthComponent;